var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({ref:"button",class:{
    'e-control': _vm.useSyncfusionComponentStyle,
    'e-btn': _vm.useSyncfusionComponentStyle,
    'e-lib': _vm.useSyncfusionComponentStyle,
  }},'button',_vm.$_button_attributes,false),_vm.$_button_listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }